
import store from '../store'

const acl = {

  can(permission) {
    // if (this.isNotLoggedIn()) {
    //   return false
    // }

    if (this.isMasterUser()) {
      return true
    }

    if (this.isAdmin()) {
      return true
    }

    return this.hasPermission(permission)
  },

  hasPermission(permission) {

    let userPermission = this.getPermission(permission)

    if (typeof userPermission == 'undefined') {
      return false
    }

    if (!userPermission) {
      return false
    }

    return (userPermission.has_permission == 1)
  },

  // isNotLoggedIn() {
  //   return (!store.loggedIn)
  // },

  getPermission(permission) {
    try {
      return store.state.auth.user.user_permissions.filter((row) => row.permission == permission)[0]
    } catch (e) {
      return false
    }
  },

  isMasterUser() {
    try {
      return (store.state.auth.user.user.is_master_user == 1)
    } catch (e) {
      return false
    }
  },

  isAdmin() {
    try {
      return (store.state.auth.user.user.is_master_user == 1 || store.state.auth.user.user.is_admin_user == 1)
    } catch(e) {
      return false
    }
  }
}

export default acl;